/* Layer order, as in tokens.css: in production this file can load before it. */
@layer gilt.tokens, gilt.base, gilt.components, gilt.utilities;

@layer gilt.components {
  /* ============================================================ Window */
  .g-window {
    position: absolute;
    display: flex;
    min-width: 0;
    pointer-events: auto;
    animation: g-dialog-in var(--dur-base) var(--ease-out);
    /* Snapping, tiling and maximizing glide; dragging follows the pointer (data-moving). */
    transition:
      left var(--dur-base) var(--ease-out),
      top var(--dur-base) var(--ease-out),
      width var(--dur-base) var(--ease-out),
      height var(--dur-base) var(--ease-out);
  }
  .g-window[data-moving] {
    transition: none;
  }
  .g-window:focus {
    outline: none;
  }
  .g-window[hidden] {
    display: none;
  }
  .g-window__frame {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: var(--bg-panel);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    box-shadow: var(--highlight), var(--shadow-md);
    overflow: hidden;
  }
  .g-window[data-active] .g-window__frame {
    border-color: var(--border-strong);
    box-shadow: var(--highlight), var(--shadow-lg);
  }
  .g-window__bar {
    display: flex;
    align-items: center;
    gap: 2px;
    height: 40px;
    padding: 0 6px;
    border-bottom: 1px solid var(--border-subtle);
    background: var(--bg-surface);
    flex-shrink: 0;
    user-select: none;
    touch-action: none;
  }
  .g-window__icon {
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 7px;
    color: var(--fg-subtle);
    flex-shrink: 0;
  }
  .g-window__icon:hover,
  .g-window__icon[aria-expanded='true'] {
    background: var(--bg-hover);
    color: var(--fg-muted);
  }
  .g-window__icon svg {
    width: 15px;
    height: 15px;
  }
  .g-window__title {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding-left: 2px;
    overflow: hidden;
    white-space: nowrap;
    font-size: var(--text-sm);
    font-weight: var(--weight-semibold);
    color: var(--fg-subtle);
  }
  .g-window[data-active] .g-window__title {
    color: var(--fg);
  }
  .g-window__actions,
  .g-window__controls {
    display: flex;
    align-items: center;
    gap: 1px;
    flex-shrink: 0;
  }
  .g-window__controls {
    margin-left: 4px;
  }
  .g-window__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  /* Resize handles straddle the frame's edge. */
  .g-window__edge {
    position: absolute;
    z-index: 1;
    touch-action: none;
  }
  .g-window__edge[data-edge='n'],
  .g-window__edge[data-edge='s'] {
    left: 10px;
    right: 10px;
    height: 8px;
    cursor: ns-resize;
  }
  .g-window__edge[data-edge='n'] {
    top: -4px;
  }
  .g-window__edge[data-edge='s'] {
    bottom: -4px;
  }
  .g-window__edge[data-edge='e'],
  .g-window__edge[data-edge='w'] {
    top: 10px;
    bottom: 10px;
    width: 8px;
    cursor: ew-resize;
  }
  .g-window__edge[data-edge='e'] {
    right: -4px;
  }
  .g-window__edge[data-edge='w'] {
    left: -4px;
  }
  .g-window__edge[data-edge='ne'],
  .g-window__edge[data-edge='nw'],
  .g-window__edge[data-edge='se'],
  .g-window__edge[data-edge='sw'] {
    width: 14px;
    height: 14px;
  }
  .g-window__edge[data-edge='ne'] {
    top: -5px;
    right: -5px;
    cursor: nesw-resize;
  }
  .g-window__edge[data-edge='nw'] {
    top: -5px;
    left: -5px;
    cursor: nwse-resize;
  }
  .g-window__edge[data-edge='se'] {
    bottom: -5px;
    right: -5px;
    cursor: nwse-resize;
  }
  .g-window__edge[data-edge='sw'] {
    bottom: -5px;
    left: -5px;
    cursor: nesw-resize;
  }

  .g-window-preview {
    position: absolute;
    border-radius: var(--radius-lg);
    background: var(--accent-soft);
    border: 1px solid var(--accent-border);
    pointer-events: none;
    animation: g-fade-in var(--dur-fast) var(--ease-out);
    transition:
      left var(--dur-fast) var(--ease-out),
      top var(--dur-fast) var(--ease-out),
      width var(--dur-fast) var(--ease-out),
      height var(--dur-fast) var(--ease-out);
  }
}
